import React, {
  useEffect,
  useCallback,
  useRef,
  useState,
  ComponentProps,
} from "react";
import { LatestWinnersList } from "@nestcoinco/hyper-api-gateway-api-client";

import "./LatestWinsSlider.scss";
import { handleGetLatestWinners } from "../../../api-clients/tournamentsExternalsClient";
import LatestWinItem from "../LatestWinItem/LatestWinItem";

const ITEM_FLIP_INTERVAL = 3000;
const WINNERS_REFETCH_INTERVAL = 30000;

function LatestWinsSlider({ className = "", ...props }: ComponentProps<"div">) {
  const [indexOfItemInView, setIndexOfItemInView] = useState(0);
  const [latestWinners, setLatestWinners] = useState<LatestWinnersList>();
  const timeoutIdRef = useRef<NodeJS.Timeout>();

  const getWinners = useCallback(async () => {
    const winners = await handleGetLatestWinners();
    setLatestWinners(winners);
  }, []);

  useEffect(() => {
    clearTimeout(timeoutIdRef.current);

    const timeoutId = setTimeout(() => {
      if (
        latestWinners?.records &&
        indexOfItemInView === latestWinners?.records?.length - 1
      ) {
        setIndexOfItemInView(0);
      } else {
        latestWinners?.records && setIndexOfItemInView((prev) => prev + 1);
      }
      timeoutIdRef.current = timeoutId;
    }, ITEM_FLIP_INTERVAL);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [indexOfItemInView, latestWinners?.records]);

  useEffect(() => {
    getWinners();

    const intervalId = setInterval(() => {
      getWinners();
    }, WINNERS_REFETCH_INTERVAL);

    return () => {
      clearInterval(intervalId);
    };
  }, [getWinners]);

  if (!latestWinners?.records.length) return null;

  return (
    <div className={`latest-wins-slider-container ${className}`} {...props}>
      {latestWinners?.records?.length &&
        latestWinners.records.map((latestWinner, i) => (
          <LatestWinItem
            key={i}
            indexOfItemInView={indexOfItemInView}
            index={i}
            winner={latestWinner}
          />
        ))}
    </div>
  );
}

export default LatestWinsSlider;
